import { createSelector } from '@reduxjs/toolkit';

import type { SCENARIO_STEP } from 'commonTypes/api/scenarios/BaseTypes';
import type { StepOfType } from 'commonTypes/api/scenarios/scenario';

import { getScenario } from 'entities/scenario';

export const selectVerificationInstructions = createSelector(getScenario, (content) => {
  return (content as StepOfType<SCENARIO_STEP.OFFER_DISBURSEMENT>)?.content.verificationInstructions;
});
